<div>
  <div
    *ngFor="let  experience of  this.experiences[dayIndex].experiencesPerDay; let experiencesPerDayIndex = index">
    <div
      [attr.draggable]="true"
      (dragstart)="onExperiencesDragStart($event, experiencesPerDayIndex)"
      (dragover)="onExperiencesDragOver($event)"
      (drop)="onExperiencesDrop($event, experiencesPerDayIndex)"
      *ngIf="experience.experience !== undefined"
         class="group bg-experience w-auto h-auto min-h-16 flex justify-between items-center rounded-lg mt-2 ">
      <div class="ps-4 flex items-center ">
        <span class="text-lg sm:text-2xl" nz-icon nzType="fire" nzTheme="fill"></span>
        <h5 *ngIf="experience?.isCustomTitle" class="px-3 cursor-pointer sm:text-xl text-base ">
          {{ experience.customTitle }}
        </h5>
        <h5 *ngIf="!experience?.isCustomTitle" class="px-3 cursor-pointer sm:text-xl text-base ">
          {{ displayTitle(experience.experience.titles, this.lang) }}
        </h5>
      </div>
    </div>
  </div>
</div>


<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.experiencesDrag.actions.close' | transloco }}</button>
  <button nz-button nzType="primary" [nzLoading]="this.isButtonLoading" (click)="this.saveRerder()">
    {{ 'itineraries.experiencesDrag.actions.save' | transloco }}
  </button>
</div>
